// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__26pTz","range":"MonthRangeSwitch_range__1wF2i","disabled":"MonthRangeSwitch_disabled__3T_LP"};